module.exports = __webpack_public_path__ + "static/media/Es.ed0a4c5a.svg";